import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import type { Role } from '@/types';

interface RequireRoleProps {
  roles: Role[];
  children: React.ReactNode;
  redirectTo?: string;
}

export default function RequireRole({ roles, children, redirectTo = '/login' }: RequireRoleProps) {
  const user = useCurrentUser();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'SUPER_ADMIN') return <>{children}</>;
  if (!roles.includes(user.role)) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
